import { action } from 'typesafe-actions';
import { MANAGEMENT_TYPES, SagaTable } from './types';

export const getDataTable = (
  table: SagaTable['table'],
  type: SagaTable['type'],
  filter: any,
) => action(MANAGEMENT_TYPES.GET_DATA_TABLE, { table, type, filter });

export const clearDataTable = (table: 'tableA' | 'tableB' | 'tableC') =>
  action(MANAGEMENT_TYPES.CLEAR_DATA_TABLE, table);

export const setDataTable = (
  table: SagaTable['table'],
  type: SagaTable['type'],
  data: any,
) => action(MANAGEMENT_TYPES.SET_DATA_TABLE, { table, type, data });

export const setFilterStatusTable = (
  table: SagaTable['table'],
  type: SagaTable['type'],
  filter: string,
) => action(MANAGEMENT_TYPES.SET_FILTER_STATUS_TABLE, { table, type, filter });

export const setFilterDateTable = (
  table: SagaTable['table'],
  type: SagaTable['type'],
  filter: Date[],
) => action(MANAGEMENT_TYPES.SET_FILTER_DATE_TABLE, { table, type, filter });
